import React, { useState } from "react";
import Select from "react-select";
import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import Pagination from '../utils/Pagination';

function MateriaPrimaTabela({ vetor, selecionar, exibirFornecedor,filtrar ,vetrores }) {
    const [descricao, setDescricao] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    // Gerando as opções para o Select
    const options = Array.from(
        new Set(vetrores.map((obj) => obj.descricao ))
    ).map((descricao) => ({
        value: descricao,
        label: descricao,
        
    }));

    // Função para atualizar a descrição quando o usuário selecionar uma opção
    const handleSelectChange = (selectedOption) => {
        setDescricao(selectedOption ? selectedOption.value : "");
        setCurrentPage(1); // Reset para primeira página quando filtrar
    };

    // Função de busca, que filtra a lista de matérias-primas com base na descrição
    const handleBuscar = () => {
        filtrar(descricao);
        setCurrentPage(1); // Reset para primeira página quando buscar
    };

    // Cálculos de paginação
    const totalItems = vetor.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
    const currentItems = vetor.slice(startIndex, endIndex);

    // Função para mudar de página
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (
        <div>

            <div className="toolbar-inline">
            <div className="search-container">
                    <Select
                        value={options.find(option => option.value === descricao) || null} // Seleciona a opção correta
                        onChange={handleSelectChange} // Lida com a mudança no select
                        options={options} // Passa as opções para o Select
                        isClearable={true} // Permite limpar o campo
                        isSearchable={true} // Mantém sugestões ao digitar
                        placeholder="Pesquisa Matéria Prima"
                        className="w-auto fixed-select" // Adiciona a classe fixada
                    />
                    <button
                        onClick={handleBuscar}
                        className="btn btn-primary btn-sm"
                    >
                        Busca
                    </button>
                </div>
            </div>

            <div className="table-responsive-container">
            <table className="table table-responsive table-mobile table-compact">
                <thead>
                    <tr>
                        <th className="col-id">ID</th>
                        <th className="col-descricao">Descrição</th>
                        <th className="col-cor">Cor</th>
                        <th className="col-custo">Custo</th>
                        <th className="col-codigo">Código</th>
                        <th className="col-um">UM</th>
                        <th className="col-status">Status</th>
                        <th className="col-saldo">Saldo em Estoque</th>
                        <th className="col-fornecedor">Fornecedor</th>
                        <th className="col-acoes">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(currentItems) && currentItems.map((obj) => {
                        const { id, descricao, cor, custo, codigoMateria,umSigla,status, idFornecedor, saldoEstoque } = obj;
                        return (
                            <tr key={id}>
                                <td className="col-id">{id}</td>
                                <td className="col-descricao text-ellipsis" title={descricao}>{descricao}</td>
                                <td className="col-cor text-ellipsis" title={cor}>{cor}</td>
                                <td className="col-custo" style={{textAlign:'right'}}>R$ {Number(custo||0).toFixed(2)}</td>
                                <td className="col-codigo" title={codigoMateria}>{codigoMateria}</td>
                                <td className="col-um" style={{textAlign:'center'}}>{umSigla}</td>
                                <td className="col-status" style={{textAlign:'center'}}>{status}</td>
                                <td className="col-saldo" style={{textAlign:'right'}}>{saldoEstoque != null ? Number(saldoEstoque).toFixed(2) : '-'}</td>
                                <td className="col-fornecedor">
                                    <button
                                        onClick={() => exibirFornecedor(idFornecedor.id)}
                                        className='btn btn-success'>
                                        Ver fornecedor
                                    </button>
                                </td>
                                <td className="col-acoes" style={{textAlign:'center'}}>
                                    <IconButton
                                        size="small"
                                        onClick={() => selecionar(id, idFornecedor)}
                                        color="primary"
                                    >
                                        <EditIcon />
                                    </IconButton>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            </div>

            <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                startIndex={startIndex}
                endIndex={endIndex}
            />
        </div>
    );
}

export default MateriaPrimaTabela;


